(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["features-hero-checks"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initFhw(el) {
    var sectionId = el.dataset.sectionId;

    var observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        el.classList.add('fhw--visible');
        observer.disconnect();
      }
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    observer.observe(el);

    function onUnload(e) {
      if (e.detail.sectionId === sectionId) {
        observer.disconnect();
        document.removeEventListener('shopify:section:unload', onUnload);
      }
    }

    document.addEventListener('shopify:section:unload', onUnload);
  }

  document.querySelectorAll('[data-fhw]').forEach(initFhw);

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-fhw]');
    if (el) initFhw(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      var stickyType = this.getAttribute('data-sticky-type');
      this.stickyDisabled = stickyType === 'none';
      this.headerIsAlwaysSticky = stickyType === 'always' || stickyType === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      // Skip scroll listener entirely when sticky is disabled — header stays in normal flow
      if (!this.stickyDisabled) {
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Logo swap: show inverse when transparent, default when solid
  (function() {
    function syncLogos(wrapper) {
      var transparent = wrapper.getAttribute('data-header-style') === 'transparent';
      wrapper.querySelectorAll('.header-logo--default').forEach(function(el) {
        el.style.setProperty('display', transparent ? 'none' : 'block', 'important');
      });
      wrapper.querySelectorAll('.header-logo--inverse').forEach(function(el) {
        el.style.setProperty('display', transparent ? 'block' : 'none', 'important');
      });
    }

    function initLogoSwap() {
      var wrapper = document.querySelector('.header-wrapper[data-header-style]');
      if (!wrapper) return;
      syncLogos(wrapper);
      new MutationObserver(function() { syncLogos(wrapper); })
        .observe(wrapper, { attributes: true, attributeFilter: ['data-header-style'] });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initLogoSwap);
    } else {
      initLogoSwap();
    }
  })();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pulse-product-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(sectionEl) {
      var track = sectionEl.querySelector('[data-prc-track]');
      if (!track) return;

      var wrapper = track.closest('.prc-wrapper');
      var btnPrev = wrapper && wrapper.querySelector('[data-prc-prev]');
      var btnNext = wrapper && wrapper.querySelector('[data-prc-next]');
      var dots = sectionEl.querySelectorAll('[data-prc-dot]');
      var cards = track.querySelectorAll('[data-prc-card]');

      function cardWidth() {
        var card = cards[0];
        return card ? card.offsetWidth + 20 : 320;
      }

      function activeIndex() {
        return Math.round(track.scrollLeft / cardWidth());
      }

      function updateState() {
        var idx = activeIndex();
        var atStart = track.scrollLeft <= 4;
        var atEnd = track.scrollLeft + track.offsetWidth >= track.scrollWidth - 4;

        if (btnPrev) btnPrev.disabled = atStart;
        if (btnNext) btnNext.disabled = atEnd;

        dots.forEach(function (dot, i) {
          dot.classList.toggle('prc-dot--active', i === idx);
        });
      }

      function scrollTo(idx) {
        track.scrollTo({ left: idx * cardWidth(), behavior: 'smooth' });
      }

      function onPrev() { scrollTo(activeIndex() - 1); }
      function onNext() { scrollTo(activeIndex() + 1); }
      function onScroll() { updateState(); }

      function onDotClick(e) {
        var dot = e.currentTarget;
        var idx = parseInt(dot.getAttribute('data-prc-dot'), 10);
        scrollTo(idx);
      }

      if (btnPrev) btnPrev.addEventListener('click', onPrev);
      if (btnNext) btnNext.addEventListener('click', onNext);
      track.addEventListener('scroll', onScroll, { passive: true });
      dots.forEach(function (dot) { dot.addEventListener('click', onDotClick); });

      updateState();

      sectionEl._prcCleanup = function () {
        if (btnPrev) btnPrev.removeEventListener('click', onPrev);
        if (btnNext) btnNext.removeEventListener('click', onNext);
        track.removeEventListener('scroll', onScroll);
        dots.forEach(function (dot) { dot.removeEventListener('click', onDotClick); });
      };
    }

    document.querySelectorAll('.shopify-section').forEach(function (el) {
      if (el.querySelector('[data-prc-track]')) initCarousel(el);
    });

    document.addEventListener('shopify:section:load', function (e) {
      if (e.target.querySelector('[data-prc-track]')) initCarousel(e.target);
    });

    document.addEventListener('shopify:section:unload', function (e) {
      if (typeof e.target._prcCleanup === 'function') e.target._prcCleanup();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
